const itemSchema = () => ({
  title: 'Item',
  fieldsets: [{ id: 'default', title: 'Default', fields: ['image', 'caption', 'alt', 'number', 'heading', 'client', 'text', 'feeling', 'link', 'video'] }],
  properties: {
    image: { title: 'Image', widget: 'object_browser', mode: 'image', allowExternals: false },
    caption: { title: 'Caption (shown under the image)' },
    alt: { title: 'Alt text (for screen readers)' },
    number: { title: 'Number (steps layout)' },
    heading: { title: 'Heading / project title' },
    client: { title: 'Client (portfolio layout)' },
    text: { title: 'Text / short description', widget: 'textarea' },
    feeling: { title: 'The feeling (portfolio layout, optional)', widget: 'textarea' },
    link: { title: 'Link (optional, portfolio layout)' },
    video: { title: 'Motion loop name (rotator layout)', description: 'e.g. feeling-energized-newhire, served from /media/feelings/' },
  },
  required: [],
});

export const sectionSchema = () => ({
  title: 'GForce section',
  fieldsets: [
    { id: 'default', title: 'Default', fields: ['layout', 'eyebrow', 'title', 'text', 'subtitle', 'button_label', 'button_href', 'button_style', 'anchor'] },
    { id: 'items', title: 'Images / steps', fields: ['items'] },
  ],
  properties: {
    layout: {
      title: 'Layout',
      choices: [
        ['hero', 'Hero (text + image)'], ['statement', 'Statement (centered)'], ['about', 'Image + text'],
        ['steps', 'Numbered steps'], ['services', 'Services grid'], ['strip', 'Image strip'], ['quality', 'Dark quote'],
        ['edit', 'Featured edit (3 images)'], ['cta', 'Call to action'], ['teaser', 'Teaser line + link'],
        ['intro', 'Page intro (large heading)'], ['portfolio', 'Portfolio grid (project cards)'], ['prose', 'Text page (## for subheads)'], ['form', 'Request a Quote form'], ['rotator', 'Rotating images (one at a time)'],
      ],
      default: 'hero',
    },
    eyebrow: { title: 'Eyebrow (small caps label)' },
    title: { title: 'Headline', description: 'Wrap words in *asterisks* for italic gray emphasis.', widget: 'textarea' },
    text: { title: 'Body text', description: 'Blank line = new paragraph.', widget: 'textarea' },
    subtitle: { title: 'Sub-headline (image + text layout)', widget: 'textarea' },
    button_label: { title: 'Button label' },
    button_href: { title: 'Button link', description: 'e.g. /request-a-quote or #quote' },
    button_style: { title: 'Button style', choices: [['dark', 'Dark'], ['outline', 'Outline']], default: 'dark' },
    anchor: { title: 'Anchor id', description: 'e.g. about, so #about links here' },
    items: { title: 'Items', widget: 'object_list', schema: itemSchema() },
  },
  required: ['layout'],
});
